export default __webpack_public_path__ + "static/media/phases.e1acacfb.jpg";